module.exports = __webpack_public_path__ + "static/media/5H.40c189c8.svg";